/* eslint-disable sort-imports */ // <--- need to keep this specific order
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import store from "@/store";

// ===== Module Imports =====
import AccountsReceivableModule from "@/store/modules/accounts-receivable";
import AlertsModule from "@/store/modules/alerts";
import ApplicationModule from "@/store/modules/application";
import AuthModule from "@/store/modules/auth";
import CallModule from "@/store/modules/call";
import CallListModule from "@/store/modules/call-list";
import DispositionsModule from "@/store/modules/dispositions";
import DocumentManagerModule from "@/store/modules/document-manager";
import EsignModule from "@/store/modules/esign";
import FacilitiesModule from "@/store/modules/facilities";
import GiftCardModule from "@/store/modules/gift-cards";
import LeadsModule from "@/store/modules/leads";
import ReportingModule from "@/store/modules/reporting";
import ReservationsModule from "@/store/modules/reservations";
import SettingsModule from "@/store/modules/settings";
import SmsOptInModule from "@/store/modules/sms-opt-in";
import SnackbarModule from "@/store/modules/snackbar";
import TenantModule from "@/store/modules/tenant";
import UserModule from "@/store/modules/user";

Vue.use(Vuex);

// ===== Axios Setup =====
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

if (sessionStorage.getItem("access_token")) {
  axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("access_token");
}

axios.interceptors.response.use(undefined, err => {
  const validAxiosError = !!(err && err.response && err.response.status);

  if (validAxiosError && err.response.status === 401) {
    // dispatch logout event
    store.dispatch("logout");
  }

  if (validAxiosError && err.response.status === 403) {
    // dispatch access denied event
    // @todo display access denied bro
  }

  return Promise.reject(err);
});

const apiV1 = axios.create({
  baseURL: process.env.VUE_APP_API_HOST
});

const apiV2 = axios.create({
  baseURL: process.env.VUE_APP_API_V2_HOST
});

export {
  apiV1,
  apiV2
};

export default new Vuex.Store({
  modules: {
    accountsReceivable: AccountsReceivableModule,
    alerts: AlertsModule,
    application: ApplicationModule,
    auth: AuthModule,
    call: CallModule,
    callList: CallListModule,
    dispositions: DispositionsModule,
    documentManager: DocumentManagerModule,
    esign: EsignModule,
    facilities: FacilitiesModule,
    giftCards: GiftCardModule,
    leads: LeadsModule,
    reporting: ReportingModule,
    reservations: ReservationsModule,
    settings: SettingsModule,
    smsOptIn: SmsOptInModule,
    snackbar: SnackbarModule,
    tenant: TenantModule,
    user: UserModule
  }
});
